<template>
  <v-row justify="center">
    <v-dialog
      v-model="alertDialog"
      persistent
      :max-width="maxWidth"
    >
      <v-card>
        <v-card-title class="headline text-black">
          {{ title }}
        </v-card-title>
        <v-card-text v-html="body" />
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="light-blue-darken-2"
            text
            rounded
            @click="closeAndAgree()"
          >
            {{ actionLabel }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
export default {
  name: 'AppAlertDialog',
  computed: {
    ...mapState('dialog', [
      'alertDialog',
      'title',
      'body',
      'action',
      'actionLabel',
      'maxWidth'
    ])
  },
  methods: {
    ...mapMutations('dialog', ['closeDialog']),

    /**
     * Hides the dialog and executes the action callback function.
     *
     */
    closeAndAgree () {
      this.closeDialog('alertDialog')
      if (this.action) this.action()
    }
  }
}
</script>
